import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
const ease = [0.23, 1, 0.32, 1] as const;
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="pb-20 lg:pb-24" aria-labelledby="faq-title" data-id="element-80" data-mp="1gj3mdt7rf5py">
      <div className="mx-auto grid max-w-7xl gap-8 px-5 lg:grid-cols-12 lg:gap-8 lg:px-8" data-id="element-81" data-mp="2496ci3s461lx">
        <h2 id="faq-title" className="font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-ink sm:text-5xl lg:col-span-4" data-id="element-82" data-mp="24bk6saeyz9sf">
          Good questions.
        </h2>
        <div className="lg:col-span-7 lg:col-start-6" data-id="element-83" data-mp="1zihjul4p6yl7">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <div key={faq.question} className="border-b border-line first:border-t" data-id="element-84" data-mp="2rysbaq4kqete" data-mpi={i}>
                <h3 data-id="element-85" data-mp="2s0lkac2ntb4k">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="group flex w-full items-center justify-between gap-6 py-5 text-left font-display text-lg font-semibold tracking-tight text-ink" data-id="element-86" data-mp="14v0sgt23to5n">
                    {faq.question}
                    <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-full transition-colors duration-200 ${isOpen ? 'bg-forest text-mint' : 'bg-white text-forest ring-1 ring-line group-hover:bg-mint-soft'}`} data-id="element-87" data-mp="1oi89yzqjn9ny">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-88" data-mp="1sledw0q6oor9" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-89" data-mp="1y9cy9dop9t3d">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease
              }} className="overflow-hidden" data-id="element-90" data-mp="1ybfzktvaz8ne">
                      <p className="max-w-2xl pb-6 leading-relaxed text-muted" data-id="element-91" data-mp="2h7p9d4z69d1l">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}